import React from 'react';
import { HistogramVignetteComponent } from '../../Vignette/Histogram';
import { ComputedProject } from '@photocarbone/nooco-shared-api-def';
import { Legend } from '../Legend';
import './histogramWithLegend.scss';

// Replace with nooco-shared when new version is published.
export interface FormatedGraphData {
  name: string;
  [key: string]: string | number;
}
type HistogramWithLegendProps = {
  graphData: FormatedGraphData[];
  graphKeys: string[];
  impactTotal: number;
  currentProject: ComputedProject;
  isPdf: boolean;
  impactUnit?: string | null;
  colors?: string[];
  pdfTitle?: string;
  i18nInstance?: any;
};

export function HistogramWithLegend({
  graphData,
  graphKeys,
  impactTotal,
  currentProject,
  impactUnit = null,
  isPdf,
  colors,
  pdfTitle,
  i18nInstance = null,
}: HistogramWithLegendProps) {
  return (
    <div
      className="wrapper-histogram-legend"
      style={isPdf ? { pageBreakInside: 'avoid' } : undefined}
    >
      <HistogramVignetteComponent
        data={graphData}
        keys={graphKeys}
        total={impactTotal}
        isPdf={isPdf}
        currentProject={currentProject}
        colors={colors}
        pdfTitle={pdfTitle}
        i18nInstance={i18nInstance}
      />
      <Legend data={graphData} totalImpact={impactTotal} impactUnit={impactUnit} />
    </div>
  );
}
